var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.129 12L16.758 8.40003C16.8356 8.32189 16.8969 8.22917 16.9384 8.12722C16.9799 8.02527 17.0009 7.91611 17 7.80603C16.9934 7.6021 16.9064 7.40907 16.758 7.26902C16.6047 7.12619 16.403 7.04677 16.1935 7.04677C15.984 7.04677 15.7823 7.12619 15.629 7.26902L12 10.871L8.40001 7.24203C8.32187 7.16448 8.22916 7.10317 8.12721 7.06164C8.02526 7.0201 7.91609 6.99916 7.80601 7.00003C7.60209 7.00666 7.40906 7.09365 7.26901 7.24203C7.13204 7.39856 7.05575 7.59903 7.05401 7.80702C7.04825 7.91346 7.06709 8.0198 7.10905 8.11778C7.15102 8.21576 7.21499 8.30276 7.29601 8.37203L10.871 12L7.24201 15.6C7.16471 15.6779 7.10354 15.7703 7.06201 15.8719C7.02048 15.9735 6.99941 16.0823 7.00001 16.192C7.00665 16.3959 7.09364 16.589 7.24201 16.729C7.39855 16.866 7.59902 16.9423 7.80701 16.944C7.9131 16.9471 8.01858 16.927 8.11614 16.8852C8.2137 16.8434 8.30101 16.7809 8.37201 16.702L12 13.129L15.6 16.758C15.6727 16.8348 15.7603 16.8959 15.8575 16.9375C15.9546 16.9791 16.0593 17.0004 16.165 17H16.192C16.3959 16.9934 16.589 16.9064 16.729 16.758C16.869 16.6048 16.9488 16.4061 16.9538 16.1986C16.9588 15.9911 16.8885 15.7888 16.756 15.629L13.129 12Z",
    fill: "var(--icon-primary-color)",
    stroke: "var(--icon-primary-color)",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.19f128bf61a38e31c6cffba83ed1861a.svg";
export { ForwardRef as ReactComponent };